import { getCss, buildResponsiveStyles, mergeDeep } from '../../utils';
import {
  TBtnGroupDirection,
  // BtnGroupDirectionType,
  TBtnGroupGutterSize,
  // BtnGroupGutterSizeType,
  TBtnGroupWrap,
  // BtnGroupWrapType,
  TBtnGroupAlignment,
  // BtnGroupAlignmentType,
  TBtnGroupJustifyContent,
} from './btn-group-utils';

export const createStyles = (
  direction: TBtnGroupDirection,
  gutterSize: TBtnGroupGutterSize,
  wrap: TBtnGroupWrap,
  alignment: TBtnGroupAlignment,
  justifyContent: TBtnGroupJustifyContent
): string => {
  return getCss({
    '@global': {
      ':host': {
        display: 'flex',
        ...mergeDeep(
          buildResponsiveStyles(direction, (directionResponsive: string) => ({
            flexDirection: directionResponsive,
          })),
          buildResponsiveStyles(gutterSize, (gutterSizeResponsive: string) => ({
            gap: `${gutterSizeResponsive}px`,
          })),
          buildResponsiveStyles(wrap, (wrapResponsive: string) => ({
            flexWrap: wrapResponsive,
          })),
          buildResponsiveStyles(alignment, (alignmentResponsive: string) => ({
            alignItems: alignmentResponsive,
          })),
          buildResponsiveStyles(justifyContent, (justifyContentResponsive: string) => ({
            justifyContent: justifyContentResponsive,
          }))
        ),
      },
      '::slotted': {
        '&(dc-ui-divider)': {
          alignSelf: 'normal',
        },
      },
    },
  });
};
